<script>
var icons = {
  plus: 'M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z',
  tic: 'M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z',
  sort: 'M14 5h8v2h-8zm0 5.5h8v2h-8zm0 5.5h8v2h-8zM2 11.5C2 15.08 4.92 18 8.5 18H9v2l3-3-3-3v2h-.5C6.02 16 4 13.98 4 11.5S6.02 7 8.5 7H12V5H8.5C4.92 5 2 7.92 2 11.5z',
  link: 'M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z',
  palettes: 'M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z',
  close: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z',
  bold: 'M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z',
  italic: 'M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z',
  underline: 'M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z',
  center: 'M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z',
  left: 'M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z',
  right: 'M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z',
  trash: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z',
  align: 'M3 21h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V7H3v2zm0-6v2h18V3H3z',
  textStyle: 'M23 7V1h-6v2H7V1H1v6h2v10H1v6h6v-2h10v2h6v-6h-2V7h2zM3 3h2v2H3V3zm2 18H3v-2h2v2zm12-2H7v-2H5V7h2V5h10v2h2v10h-2v2zm4 2h-2v-2h2v2zM19 5V3h2v2h-2zm-5.27 9h-3.49l-.73 2H7.89l3.4-9h1.4l3.41 9h-1.63l-.74-2zm-3.04-1.26h2.61L12 8.91l-1.31 3.83z',
  section: 'M10 18h5v-6h-5v6zm-6 0h5V5H4v13zm12 0h5v-6h-5v6zM10 5v6h11V5H10z',
  arrowDown: 'M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z',
  arrowRight: 'M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z',
  arrowLeft: 'M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z',
  mobile: 'M15.5 1h-8C6.12 1 5 2.12 5 3.5v17C5 21.88 6.12 23 7.5 23h8c1.38 0 2.5-1.12 2.5-2.5v-17C18 2.12 16.88 1 15.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z',
  tablet: 'M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 1.99-.9 1.99-2L23 6c0-1.1-.9-2-2-2zm-2 14H5V6h14v12z',
  laptop: 'M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z',
  monitor: 'M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H3V4h18v12z',
  download: 'M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z',
  eye: 'M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z',
  undo: 'M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z',
  fontSize: 'M18.79,2.38,17.41,0h5.53L21.55,2.38l-1.39,2.4Zm2.07,6.51H19.47L16.18,17.6,9.51,0H6.74L0,17.86H3.21l1.45-4h6.92l1.46,4H17.7l.72-2H21.9l.74,2h1.62ZM5.63,11.39,8.15,3.8l2.57,7.59Zm13.28,3.22,1.27-3.82,1.29,3.82Z',
  twelve: 'M3,2.91H3L.5,4.09,0,1.81,3.43.22H5.94v13H3ZM10.2,13.17V11.34l1.68-1.52c2.83-2.53,4.2-4,4.24-5.5,0-1.05-.63-1.89-2.13-1.89a4.71,4.71,0,0,0-2.77,1.08l-.86-2.18A7.26,7.26,0,0,1,14.61,0c2.93,0,4.54,1.71,4.54,4.07,0,2.17-1.57,3.9-3.44,5.58l-1.2,1v0h4.88v2.49Z',
  forteen: 'M3,2.69H3L.5,3.87,0,1.59,3.43,0H5.94V13H3ZM15.57,13V9.86H9.83v-2L14.73,0h3.7V7.59H20V9.86H18.43V13Zm0-5.36V4.72c0-.77,0-1.57.1-2.41h-.09c-.41.84-.75,1.6-1.19,2.41L12.66,7.55v0Z',
  sixteen: 'M3,2.88H3L.5,4.06,0,1.79,3.43.19H5.94v13H3Zm15.46-.54a10.1,10.1,0,0,0-1.17,0c-2.69.22-3.89,1.6-4.23,3.11h.06a3.69,3.69,0,0,1,2.75-1,3.93,3.93,0,0,1,4,4.22,4.63,4.63,0,0,1-4.78,4.68C11.66,13.36,10,10.79,10,7.7A7.71,7.71,0,0,1,12.26,2a7.73,7.73,0,0,1,5-1.92,8.55,8.55,0,0,1,1.21,0Zm-1.65,6.5a2,2,0,0,0-3.73-1.08,1.75,1.75,0,0,0-.12.76c.06,1.38.72,2.61,2.1,2.61C16.14,11.13,16.82,10.16,16.82,8.84Z',
  eighteen: 'M3,2.91H3L.5,4.09,0,1.81,3.43.22H5.94v13H3Zm7,6.88a3.42,3.42,0,0,1,2.31-3.25V6.48a3.15,3.15,0,0,1-1.88-2.83C10.44,1.46,12.42,0,15,0c3,0,4.28,1.75,4.28,3.33a3.17,3.17,0,0,1-1.87,2.85v.06a3.43,3.43,0,0,1,2.37,3.23c0,2.35-2,3.92-5,3.92C11.52,13.39,10,11.54,10,9.79Zm6.69-.1c0-1.14-.84-1.82-2-2.14a2,2,0,0,0-1.58,1.94,1.78,1.78,0,0,0,1.84,1.81A1.63,1.63,0,0,0,16.7,9.69ZM13.29,3.55c0,.87.8,1.43,1.84,1.75a1.78,1.78,0,0,0,1.31-1.65,1.49,1.49,0,0,0-1.57-1.6A1.45,1.45,0,0,0,13.29,3.55Z'
};

export default {
  name: 'MergeIcon',
  functional: true,
  props: {
    name: {
      type: String,
      required: true,
    }
  },
  render: function render (h, ref) {
    var props = ref.props;

    var path = h('path', {
      attrs: {
        d: icons[props.name]
      }
    });

    return h(
      'svg',
      {
        attrs: {
          version: '1.1',
          xmlns: 'http://www.w3.org/2000/svg',
          class: 'merge-icon',
          viewBox: '0 0 24 24'
        }
      },
      [path]
    );
  }
}
</script>
<style lang="scss" scoped>
  .merge-icon{
    display:block;width:20px;height:20px
  }
</style>


